import styled, { css } from 'styled-components';
import { isIOS } from '@CS/utils/Device';

type PreviewAttributes = {
  large?: boolean;
};

export const Preview = styled.canvas(
  ({ large }: PreviewAttributes) => css`
    width: calc(100vw - 2rem) !important;
    transform: translateX(-50%);

    height: 100% !important;
    position: absolute;

    display: block;
    z-index: 1;
    left: 50%;

    ${large &&
    css`
      width: 100vw !important;

      ${isIOS &&
      css`
        touch-action: pinch-zoom !important;
      `}
    `}
  `
);

export const Screenshot = styled.canvas`
  pointer-events: none;
  visibility: hidden;
  position: fixed;
  display: none;

  margin: auto;
  height: 100%;
  width: 100%;
  z-index: 2;

  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;

export const Resized = styled(Screenshot)`
  height: unset;
  width: unset;
`;
